import React, { Component } from "react";
import Image from '../global/Image';
import { Link } from 'react-router-dom';


export default class PageHomesItem extends Component {

	constructor(props) {
		super(props)
		this.onIntersection = this.onIntersection.bind(this)
		this.state = {
			inView: false,
		}
	}

	componentDidMount() {
		if (this.$box) {
			let loadObserver;
			let options = {
				root: null,
				rootMargin: "-20% 0px -20% 0px",
				threshold: 0
			};
			let observer = new IntersectionObserver(this.onIntersection, options);
			observer.observe(this.$box);
		}
	}

	onIntersection(entries, observer) {
	    entries.map((entry) => {
			if (entry.intersectionRatio > 0 && this.state.inView === false) {
				this.setState({ inView: true });
			}						
		});
	} 
		  	
	render () {
		
		let block = this.props.block;
		let index = this.props.index;
										
	    return (
		    
			<div className={'c-page__block ' + (this.state.inView ? "state-in-view" : "")} ref={(box) => { this.$box = box; }}>
		     
				<div className={'c-home ' + (index % 2 === 1 ? "c-home--dark" : "")} data-index={index}>

			    	<div className="c-home__inner">
			    	
			    		{block.heading &&
				    		<div className={'c-home__header'}>
				    			<h2 className="c-home__heading" dangerouslySetInnerHTML={ {__html: block.heading}}></h2>
				    			<Link to={{ pathname: block.url }} className="c-home__button c-home__button--desktop">Find Out More</Link>
				    		</div>
			    		}
			    				    			
		    			<div className="c-home__image">
		    				<Link to={{ pathname: block.url }} className="c-home__image__inner">
								<Image srcset={block.srcset} src={block.src} />
							</Link>
						</div>
						
						<Link to={{ pathname: block.url }} className="c-home__button c-home__button--mobile">Find Out More</Link>
										    					    
					</div>
					
				</div>
				
		    </div>
		)
	}
}
